export const TITLE_PAGE = 'Obtén tus productos al instante en la Zona Digital Pichincha';
export const TITLE_NOT_AVAILABLE = 'Venta digital se encuentra en mantenimiento.';
export const TEXT_NOT_AVAILABLE = 'En poco tiempo estaremos disponibles para tí.';

export const enum OutOffice {
  OutOfficeHoursEnd = '06:00:00',
  OutOfficeHoursStart = '22:00:00',
}

export const enum UnHappyPathModal {
  NO_CONFIRM_MODAL = 'NO_CONFIRM_MODAL',
  IDLE_TIMEOUT_MODAL = 'IDLE_TIMEOUT_MODAL',
}

export const enum FooterType {
  DEFAULT = 'DEFAULT',
  HOME = 'HOME',
  LOAN = 'LOAN',
  FTD = 'FTD',
  FTD_CONFIG = 'FTD_CONFIG',
}

export const HOME_SPLASH = 'inicio';

export const LOAN_SPLASH = 'prestamo-personal';

export const FTD_SLAH = 'plazo-fijo';

export const ACCOUNT_SPLASH = 'abrir-cuenta';

export const ENROLLMENT_SPLASH = 'registro-usuario';

export const urlHome = '#/inicio';

export const ftdUrl = {
  redirection: '#/plazo-fijo/abrir-deposito/redireccion',
  firstPage: '/#/plazo-fijo/abrir-deposito/datos-personales',
};

export const AccUrl = {
  redirection: 'redireccion',
  firstPage: 'abrir-cuenta',
};
